import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Loader } from "@itandi/itandi-bb-ui/Loader";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import Link from "next/link";
import type React from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { VendorUserList } from "~/components/specifics/vendors/settings/vendor_users/VendorUserList";
import { VendorSessionProvider } from "~/context/VendorSession";
import { useSessions } from "~/hooks/vendors/useSessions";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

export const Page: React.FC = () => {
	const { data: session, isLoading } = useSessions().index();

	if (isLoading || session === null) {
		return <Loader />;
	}

	return (
		<VendorSessionProvider session={session}>
			<VendorLayoutV2>
				<VendorSettingLayout>
					<div className={SettingStyles.SpBreadcrumbsWrapper}>
						<Breadcrumbs
							items={[
								{ as: Link, href: PATH, label: "設定一覧" },
								{ label: "担当者管理" }
							]}
						/>
					</div>
					<Panel>
						<PanelHeader title="担当者管理" />
						<PanelBody>
							<VendorUserList />
						</PanelBody>
					</Panel>
				</VendorSettingLayout>
			</VendorLayoutV2>
		</VendorSessionProvider>
	);
};
